<template>
  <div>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.name"
          hideDetails
          outlined
          data-cy="flowMeter-Name"
          :label="$t('forms.labels.name')"
          :rules="{ required: true }"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.unitsOfMeasure"
          hideDetails
          outlined
          data-cy="flowMeter-unitOfMeasure"
          :label="$t('devices.measureUnit')"
          :rules="{ required: true }"
          :items="genericVolumes"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.dataSource"
          hideDetails
          outlined
          data-cy="flowMeter-channel"
          :label="$t('devices.type')"
          :rules="{ required: true }"
          :items="types"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- This VSelect will only be displayed if data.dataSource is 'IOT' -->
    <v-row v-if="data.dataSource === SOURCE_IOT">
      <v-col class="noYPadding">
        <!-- Assuming you have another VSelect to show -->
        <VTextField
          v-model="data.resetAt"
          hideDetails
          outlined
          type="number"
          data-cy="flowMeter-resetAt"
          :rules="{ required: true }"
          :label="$t('devices.flowMeters.resetAt')"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row v-if="data.dataSource === SOURCE_IOT">
      <v-col class="noYPadding">
        <VTextField
          v-model="data.volumePerPulse"
          hideDetails
          type="number"
          outlined
          data-cy="flowMeter-volumePerPulse"
          :label="$t('devices.volumePerPulse')"
          :rules="{ required: true }"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import volumes from '@/aquassist-shared/constants/volumes';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { SOURCE_IOT, SOURCE_CONTROLLER, SOURCE_MANUAL } from '@/aquassist-shared/constants/types/flowMeters';

export default {
    name: 'FlowMeterForm',
    components: {
        VSelect,
        VTextField,
    },
    props: {
        meter: {
            type: Object,
            default: () => ({}),
        },
        dataSource: {
            type: String,
            default: 'flowMeterHub',
        },
    },
    data() {
        return {
            data: {
                name: '',
                channel: '',
                unitOfMeasure: '',
                volumePerPulse: null,
                dataSource: SOURCE_IOT,
                resetAt: null,
            },

        };
    },
    computed: {
        genericVolumes() {
            return volumes.genericVolumes.filter(v => v.tag.includes('flowMeters'));
        },
        types() {
            let types = [];
            if (this.dataSource === 'flowMeterHub') {
                // Return types relevant when the source is 'hub'
                types = [
                    {
                        name: this.$t(`devices.flowMeters.sources.${SOURCE_IOT}`),
                        value: SOURCE_IOT,
                    },
                    // Potentially other types specific to 'hub'
                ];
            } else {
                // Return a default set of types or types relevant for other sources
                types = [
                    {
                        name: this.$t(`devices.flowMeters.sources.${SOURCE_IOT}`),
                        value: SOURCE_IOT,
                    },
                    {
                        name: this.$t(`devices.flowMeters.sources.${SOURCE_CONTROLLER}`),
                        value: SOURCE_CONTROLLER,
                    },
                    {
                        name: this.$t(`devices.flowMeters.sources.${SOURCE_MANUAL}`),
                        value: SOURCE_MANUAL,
                    },
                    // You can add more types here that are applicable for other sources
                ];
            }
            return types;
        },
        SOURCE_IOT() {
            return SOURCE_IOT;
        },
    },
    mounted() {
        this.data = { ...this.data, ...this.meter };
    },
    methods: {
        updateData() {
            if (typeof (this.data.resetAt) === 'string') {
                this.data.resetAt = Number(this.data.resetAt);
            }
            this.$emit('sendData', this.data);
        },
    },
};
</script>
